import * as React from "react";
import { socialPlatforms } from "../../../../constants/social-platforms";
import isEmpty from "lodash.isempty";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import "./sidebar-links.scss";

interface ComponentProps {
  subject: Person | Entity;
}

type Props = ComponentProps;

export const SidebarLinks = (props: Props) => {
  const { subject } = props;

  const profiles = subject?.socialMediaProfiles?.reduce((acc, item) => {
    acc[item.platform.kind] = item.link;
    return acc;
  }, {});

  const items =
    profiles &&
    Object.keys(socialPlatforms).reduce((acc, kind) => {
      if (isEmpty(profiles[kind])) {
        return acc;
      }
      const link = profiles[kind];
      const name = socialPlatforms[kind].name;
      const icon = socialPlatforms[kind].icon2;
      acc.push({ kind, link, name, icon });
      return acc;
    }, []);

  return (
    <div className="sidebar-links-container">
      {items &&
        items.map((profile) => {
          const link = profile?.link?.includes("http") ? profile?.link : `//${profile?.link}`;
          return (
            <SocialLink key={`social-link${profile.kind}`} link={link} kind={profile.kind}>
              {profile.icon}
            </SocialLink>
          );
        })}
    </div>
  );
};

const SocialLink = ({ children, link, kind }) => {
  return (
    <a rel="noreferrer" href={link} target="_blank" className={`btn-link ${kind}`}>
      {children}
    </a>
  );
};
